// extracted by mini-css-extract-plugin
export default {"pay":"styles_pay__tZlcu","payshit":"styles_payshit__sbYXv","paybut":"styles_paybut__1LSMo","contactline":"styles_contactline__1rrRr","emailred":"styles_emailred__VdBFJ"};